export {default as SecondMergeScreen} from './SecondMergeScreen.connect';
